import { ListItemButton, styled } from '@mui/material';

import { BlockThemed } from '/shared/BlockThemed';

export const AppPlatformsStyled = styled(BlockThemed)`
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export const AppPlatformItem = styled(ListItemButton)`
  display: flex;
  justify-content: space-around;
  padding: 0 0 0 ${({ theme }) => theme.spacing(1)};
  text-transform: none;
`;
